'use strict';

require('../../style/index.less');

require('../../grid/style/index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/col/style/index.js
// module id = 820
// module chunks = 0